export type UrlMatcher = (url: string) => boolean;

export function UrlEquals(targetUrl: string): UrlMatcher {
  return (url: string) => url === targetUrl;
}

export function UrlLike(regex: RegExp): UrlMatcher {
  return (url: string) => regex.test(url);
}

export function UrlPathEquals(targetPath: string): UrlMatcher {
  return (urlStr: string) => {
    try {
      const url = new URL(urlStr);
      return url.pathname === targetPath;
    } catch (err) {
      console.error(`UrlPathEquals() could not parse invalid url ${urlStr}`);
      return false;
    }
  };
}
